<template>
  <v-app id="inspire">
    <Loader ref="Loader"></Loader>
    <ErrorModal ref="ErrorModal"></ErrorModal>
    <SuccessModal ref="SuccessModal"/>
    <v-content>
      <v-img
        style="position:fixed; width:100%; height:100%;"
        position="100% 100%"
        src="Attraction/Login.jpeg"
        gradient="to top right, rgba(100,115,201,.33), rgba(25,32,72,.7)"
      ></v-img>
      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <v-flex xs12 sm6 md4 lg4 xl4>
            <v-card class="elevation-12" color="rgb(255, 255, 255, 0.6">
              <v-form @submit.prevent="requestCode" v-if="!showCodeForm && !showChangePasswordForm">
                <v-card-text>
                  <!-- <v-layout align-center justify-center row mb-2>
                    <v-avatar size="100" color="grey lighten-4">
                      <img src="https://vuetifyjs.com/apple-touch-icon-180x180.png" alt="avatar">
                    </v-avatar>
                  </v-layout>-->
                  <!-- <div class="display-1 text-xs-center">System name</div> -->
                  <h4>{{TranslateText('Enter a valid email address to contiune')}}</h4>
                  <v-text-field
                    v-model="EmailAddress"
                    color="primary"
                    id="password"
                    prepend-icon="lock"
                    name="password"
                    :label="TranslateText('Email')"
                    type="text"
                  ></v-text-field>
                </v-card-text>
                <v-btn
                  block
                  color="primary"
                  type="submit"
                  :disabled="EmailAddress.length == 0"
                >{{TranslateText('Send Verfication Code')}}</v-btn>
                <v-btn
                  block
                  color="primary"
                  @click="showCodeForm = true"
                  :disabled="EmailAddress.length == 0"
                >{{TranslateText('Already have a code?')}}</v-btn>
              </v-form>
              <v-form v-if="showCodeForm">
                <v-card-text>
                  <p>We have emailed you a verification code.
                    <br>
                    <b>Please leave this page open</b>
                    <br>It may take a few minutes to receive the email.
                  </p>
                  <v-text-field
                    v-model="Code"
                    prepend-icon="lock"
                    name="login"
                    label="Enter your code"
                    type="text"
                  ></v-text-field>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" block @click="verifyCode">Verify Code</v-btn>
                </v-card-actions>
              </v-form>
              <v-form v-if="showChangePasswordForm">
                <v-card-text>
                  <p>We have verified that it is you. Please enter a new password.</p>
                  <v-text-field
                    v-model="newPassword"
                    prepend-icon="lock"
                    name="password"
                    label="New password"
                    type="password"
                  ></v-text-field>
                  <v-text-field
                    v-model="confirmNewPassword"
                    prepend-icon="lock"
                    name="password"
                    label="Confirm password"
                    type="password"
                  ></v-text-field>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" @click="changePassword">Change Password</v-btn>
                  <v-btn flat @click="BackToLogin">cancel</v-btn>
                </v-card-actions>
              </v-form>
              <v-progress-linear indeterminate color="white" class="mb-0" v-if="loading"></v-progress-linear>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
    <v-footer app dark inset fixed color="darkgray">
      <v-spacer></v-spacer>
      <div>Powered by DevInspire (Pty) Ltd. &copy; {{ new Date().getFullYear() }}</div>
    </v-footer>
  </v-app>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      EmailAddress: "",
      showCodeForm: false,
      showChangePasswordForm: false,
      Code: "",
      loading: false,
      newPassword: "",
      confirmNewPassword: ""
    };
  },
  methods: {
    requestCode() {
      let self = this;
      let config = JSON.parse(sessionStorage.Config);
      self.loading = true;

      axios
        .post(config.ServerAddress + "ForgotPassword", {
          EmailAddress: self.EmailAddress
        })
        .then(result => {
          if (result.data === true) {
            self.loading = false;
            self.showCodeForm = true;
          } else {
            self.loading = false;
            alert("The email entered could not be found.");
          }
        })
        .catch(error => {
          self.loading = false;
          alert(
            "We could not process your request at this time. Please contact our support landline"
          );
          //   self.$swal(
          //     "We could not process your request at this time. Please contact our support landline",
          //     "Unknow : " + error.toString(),
          //     "error"
          //   );
        });
    },
    verifyCode() {
      let self = this;
      let config = JSON.parse(sessionStorage.Config);
      axios
        .post(config.ServerAddress + "VerifyCode", {
          EmailAddress: self.EmailAddress,
          Code: self.Code
        })
        .then(result => {
          if (result.data === true) {
            self.showCodeForm = false;
            self.showChangePasswordForm = true;
          } else {
          }
        })
        .catch(error => {});
    },
    changePassword() {
      let self = this;
      let config = JSON.parse(sessionStorage.Config);
      axios
        .post(config.ServerAddress + "ResetPassword", {
          EmailAddress: self.EmailAddress,
          Code: self.Code,
          NewPassword: self.newPassword
        })
        .then(result => {
          if (result.data === true) {
            self.$refs.SuccessModal.show();
            self.$refs.SuccessModal.setText(
              "Password Changed Successfully, this window will close in 5 seconds"
            );
            setTimeout(() => {
              window.close();
            }, 5000);
            //this.$router.push("/Login");
          }
        })
        .catch(error => {});
    }
  }
};
</script>

